import React, { useCallback, useMemo, useState } from 'react'
import { withStyles } from '@material-ui/core'
import {DepsSuccessorsPopover, managerGanttRef, managerGroupGantt} from '@tuqqi/web'

const styles = theme => ({
})


const getPreds = (docId) => {
    const recs = managerGanttRef.gantt?.instance?.project?.dependencyStore?.allRecords ?? []
    const filtered = recs
        .filter(x => x.to === docId)
        .map(x => x.from)
        .filter(x => !!x)
    return filtered
}

const CellRenderSucEdit = (props) => {
    const {record, value, containerRef} = props
    const groupUid = managerGroupGantt.getCurrentGroupUid()
    const [preds] = useState(getPreds(props.record.id))

    const _onChange = useCallback((value) => {
        props.onChange(value)
    }, [])

    const onClose = () => {
        props.onClose()
    }
    const onSucessApi = () => {
    }

    const localVal = value.map(x => x.id)

    const excludeIds = useMemo(() => {
        return [record.id, ...localVal, ...preds]
    }, [record.id, localVal, preds])

    const popoverMaxHeight = useMemo(() => {
        return 44 * 5
    }, [])
    
    return <DepsSuccessorsPopover 
            ignoreIds={excludeIds}
            popoverMaxHeight={popoverMaxHeight}
            focused={true}
            onClose={onClose}
            isSuccesors
            groupUid={groupUid}
            isPinned={false}
            onSucessApi={onSucessApi}
            docId={record.id}
            refContainer={containerRef}
            itemHeight={40}
            value={localVal} 
            onChange={_onChange} 
    />
}

export default withStyles(styles, {withTheme: true})(CellRenderSucEdit)